import { BookingDetails } from '~/lib/api/smartsend/types';
import ProviderName from '../../../lib/helpers/ProviderName';
import { Parcel2GoProvider, SmartSendProvider } from '~/lib/consts/providers';

export function BookedItemPanelHeader(props: BookingDetails, orderLinePrefix?: string): string {
  if (!props) {
    return `External Booking`;
  }

  if (props.Service?.Provider === SmartSendProvider || props.Service?.Provider === Parcel2GoProvider) {
    return props.Reference || `${orderLinePrefix}${props.OrderLineId}`;
  }

  return `${ProviderName(props.Service?.Provider)} Ref: ${props.Reference || props.OrderLineId}`;
}
